import React from 'react';
import { FallbackVisualization } from '../Components/FallbackVisualization/FallbackVisualization';
import  FallbackVisualizationContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/FallbackVisualization';

export default (props) => (
    <FallbackVisualizationContainer
      Component={FallbackVisualization}
      {...props}
    />
  );
  